import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { ApiError } from "@/lib/api/client";
import { teachingCoursesApi } from "@/lib/api/teachingCourses";

export const teachingCoursesQueryKey = (
  tenantId: string | null | undefined,
  userId: string | null | undefined,
) => ["teaching-courses", tenantId ?? "unresolved", userId ?? "unresolved"] as const;

/** A stable directory shared by navigation and discovery, scoped to identity. */
export function useTeachingCourses(enabled = true) {
  const { me } = useAuth();
  const query = useQuery({
    queryKey: teachingCoursesQueryKey(me?.tenant_id, me?.user_id),
    enabled: enabled && Boolean(me?.tenant_id && me?.user_id),
    queryFn: teachingCoursesApi.list,
    retry: (failureCount, error) =>
      error instanceof ApiError && error.status >= 400 && error.status < 500
        ? false
        : failureCount < 1,
  });
  // A stale network result may remain visible with a notice. An authorization
  // refusal must withdraw links immediately, including on a failed refresh.
  const refused = query.error instanceof ApiError
    && [401, 403, 404].includes(query.error.status);
  return {
    ...query,
    data: refused || !enabled ? undefined : query.data,
    isNoSeat: query.error instanceof ApiError && query.error.status === 404,
  };
}
